export const validations:{[key:string]:string} ={
  "block":"Select blocks from the dropdown.",
  "ulb":"Select ulbs from the dropdown.",
  "district":"Select districts from the dropdown.",
  "sub_district":"Select sub districts from the dropdown.",
  "health_block_name":`Health Block name is mandatory.`,
  "sub_division":"Sub Division name is mandatory.",
  "villages":"Select villages from the dropdown.",
  "gram_panchayat":"Select Gram Panchayat / ADC Village from the dropdown.",
  "wards":"Select wards from the dropdown.",
  "healthBlock_exists":"The name already exists. Choose a unique name to continue.",
  "effectiveFromDate":"Select effective from date to create new version."
}

export const manageHealthFacilityJson = async(payload: any) => {
  const mainPayload: any = JSON.parse(JSON.stringify(payload));

  let combinedChunks: any[] = [];
  let wardChunks: any[] = [];
  let villageChunks: any[] = [];

  const chunkArray = async(arr: any, size: any) => {
    const result = [];
    for (let i = 0; i < arr.length; i += size) {
    result.push(arr.slice(i, i + size));
    }
    return result;
  }

  const combineChunkArray = async() => {
    const maxChunks = Math.max(villageChunks.length, wardChunks.length);
    combinedChunks = [];
    for (let i = 0; i < maxChunks; i++) {
        combinedChunks.push({
        villageId: villageChunks[i] || [], // fallback to [] if missing
        wardId: wardChunks[i] || [] // fallback to [] if missing
        });
      }
  }
  
  if ((payload.villageIds.length > 0 && payload.villageIds.length > 50) || (payload.wardIds.length > 0 && payload.wardIds.length > 50)) {
    mainPayload.villageIds = payload.villageIds.slice(0, 50);
    mainPayload.wardIds = payload.wardIds.slice(0, 50);
    villageChunks = await chunkArray(payload.villageIds.slice(50), 50)
    wardChunks = await chunkArray(payload.wardIds.slice(50), 50);
    await combineChunkArray();
  }

  return {mainPayload: mainPayload, combinedChunks: combinedChunks};
}